import * as React from 'react';
import classnames from 'classnames';
import { withStyles, WithStyles } from '@material-ui/core';

import { Button, ButtonProps } from 'components/v2';
import styles from './AppointmentItemContainer.styles';

interface IAppointmentItemContainer extends Omit<ButtonProps, 'classes' | 'id'>, WithStyles<typeof styles> {
  id: string | number;
  isAppointmentSelected?: boolean;
  isRescheduleEnabled: boolean;
  isCancelEnabled: boolean;
  onClick?: () => void;
}

const AppointmentItemContainer: React.FunctionComponent<IAppointmentItemContainer> = (props) => {
  const { children, classes, id, isAppointmentSelected, onClick, ...othersProps } = props;

  return (
    <Button
      data-lh-id={`btn-appointment-${id}`}
      key={id}
      className={classnames(classes.button, {
        [classes.selectedButton]: isAppointmentSelected,
      })}
      onClick={onClick}
      extraRounded
      {...othersProps}
    >
      {children}
    </Button>
  );
};

export default withStyles(styles)(AppointmentItemContainer);
